/**
 * Bundle Sticky Summary Bar - SOTE Mobile CRO
 * Hooks into Jolly Commerce bundle builder DOM
 */
(function() {
  'use strict';

  if (window.innerWidth > 768) return;
  if (!document.querySelector('jolly-bundle')) return;

  var bar = null;
  var itemCountEl = null;
  var totalPriceEl = null;
  var ctaBtn = null;

  function createBar() {
    bar = document.createElement('div');
    bar.className = 'bundle-sticky-bar';
    bar.innerHTML =
      '<div class="bundle-sticky-content">' +
        '<div class="bundle-sticky-summary">' +
          '<span class="bundle-item-count">Select items</span>' +
          '<span class="bundle-total-price"></span>' +
        '</div>' +
        '<button class="bundle-sticky-cta" type="button" disabled>Add to Cart</button>' +
      '</div>';
    document.body.appendChild(bar);
    itemCountEl = bar.querySelector('.bundle-item-count');
    totalPriceEl = bar.querySelector('.bundle-total-price');
    ctaBtn = bar.querySelector('.bundle-sticky-cta');

    ctaBtn.addEventListener('click', function() {
      // Find Jolly Commerce's main ADD TO CART button (not GemPages)
      var jcBtn = null;
      document.querySelectorAll('button.jc-toggle-load').forEach(function(b) {
        if (b.textContent.includes('ADD TO CART')) jcBtn = b;
      });
      if (jcBtn && !jcBtn.disabled) {
        jcBtn.click();
        return;
      }
      // Fallback: scroll to the JC button so user can see it
      if (jcBtn) jcBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  function getState() {
    var bundle = document.querySelector('jolly-bundle');
    if (!bundle) return { count: 0, price: 0 };

    var cards = bundle.querySelectorAll('jolly-bundle-product-card');
    var totalItems = 0;

    cards.forEach(function(card) {
      var controls = card.querySelector('.js-controls');
      var isActive = controls && controls.getAttribute('data-show-controls') === 'true';
      if (!isActive) return;

      var qtySpan = card.querySelector('.js-quantity-value');
      var qty = qtySpan ? (parseInt(qtySpan.textContent.trim(), 10) || 0) : 0;
      totalItems += qty;
    });

    // Get tier price: check active progress pin
    var tierPriceCents = parseInt(bundle.getAttribute('data-base-product-price') || '0', 10);
    var activeTier = bundle.querySelector('.js-progress-pin.active');
    if (activeTier) {
      var priceSpan = activeTier.querySelector('.js-progress-item-price');
      if (priceSpan) {
        var match = priceSpan.textContent.match(/\$([\d.]+)/);
        if (match) tierPriceCents = Math.round(parseFloat(match[1]) * 100);
      }
    }

    return { count: totalItems, price: totalItems * tierPriceCents };
  }

  function update() {
    if (!bar) return;
    var state = getState();

    if (state.count === 0) {
      itemCountEl.textContent = 'Select items';
      totalPriceEl.textContent = '';
      ctaBtn.disabled = true;
      ctaBtn.style.background = '#ccc';
    } else {
      itemCountEl.textContent = state.count + ' item' + (state.count !== 1 ? 's' : '');
      totalPriceEl.textContent = '$' + (state.price / 100).toFixed(2);
      ctaBtn.disabled = false;
      ctaBtn.style.background = '#061e59';
    }
  }

  function handleScroll() {
    if (!bar) return;
    bar.classList.toggle('visible', window.scrollY > 300);
  }

  createBar();
  update();

  var scrollTimer;
  window.addEventListener('scroll', function() {
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(handleScroll, 50);
  }, { passive: true });

  var bundle = document.querySelector('jolly-bundle');
  if (bundle) {
    new MutationObserver(function() { setTimeout(update, 100); })
      .observe(bundle, { childList: true, subtree: true, attributes: true, characterData: true });
  }

  setInterval(update, 2000);

  window.addEventListener('resize', function() {
    if (window.innerWidth > 768 && bar) bar.classList.remove('visible');
  });
})();
